/** Enquêtes actives et configuration du mapping RPS global. */
import { useState } from "react"
import RpsMappingModal from "./RpsMappingModal"
import Modal from "@/components/modal"
import RpsSurveyList from "@/entities/physical-risk/ui/RpsSurveyList"

interface Props {
  onClose: () => void
}

export default function RpsSurveyImportModal({ onClose }: Props) {
  const [mappingOpen, setMappingOpen] = useState<"manual" | "assistant" | null>(null)
  return (
    <Modal disableKeyEvents={Boolean(mappingOpen)} isLarge title="Enquêtes RPS" isCloseButtonVisible onClose={onClose}>
      {mappingOpen && <RpsMappingModal suggest={mappingOpen === "assistant"} onClose={() => setMappingOpen(null)} />}
      <RpsSurveyList className="modal-content-list" onConfigure={(suggest) => setMappingOpen(suggest ? "assistant" : "manual")} />
    </Modal>
  )
}
